// Note: This interceptor could be trivially combined with the
//       API interceptor. However, they are being kept deliberately
//       separate despite the obvious duplicate code

// EXPERIMENT: create a separate AuthError interceptor to replace the
// messy (untested) plumbing that I put in here
// See also: README.md#http-interceptor-architecture-hybrid

import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class BffInterceptor implements HttpInterceptor {
  // Purpose:
  // - Apply BFF-specific request requirements for Angular HttpClient calls.
  // - Keep this focused on request shaping only (no error handling here).
  // Why separate from ApiInterceptor?
  // - Routing intent is clearer in a hybrid codebase where /bff and /api* calls
  //   are owned by different migration paths.
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // For BFF endpoints, always send cookies and the BFF anti-CSRF header.
    // The X-CSRF marker is intentionally simple; the backend enforces meaning.
    if (this.hasPathPrefix(req.url, '/bff/')) {
      const headers = req.headers.has('X-CSRF')
        ? req.headers
        : req.headers.set('X-CSRF', '1');

      const httpsReq = req.clone({
        withCredentials: true,
        headers
      });

      return next.handle(httpsReq);
    }

    // Non-BFF traffic is untouched.
    return next.handle(req);
  }

  private hasPathPrefix(url: string, prefix: string): boolean {
    return this.getRequestPath(url).startsWith(prefix);
  }

  private getRequestPath(url: string): string {
    try {
      return new URL(url, window.location.origin).pathname || '';
    } catch {
      return (url || '').split('?')[0].split('#')[0];
    }
  }
}
